import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col } from 'antd';
import {
  INDICADOR_ESPECTACULARES,
  INDICADOR_INTERNET,
  INDICADOR_EVENTOS,
  INDICADOR_CASAS,
  INDICADOR_M_I
} from 'constants/monitoringHomeTypes';
import './FlipCard.scss';

const FlipCard = ({ detalle, nombre, resumen, handleGetFileUriSvg, llave, idTipo }) => {
  // console.log('FlipCard', nombre, detalle, resumen);
  const [flipped, setFlipped] = useState(false);

  const handleFlip = () => {
    setFlipped(!flipped);
  };

  /** Manejo de mayúsculas en palabras */
  const capitalizeWords = (str) => {
    if (['CIUDAD DE MEXICO'].includes(str)) {
      return 'Ciudad de México';
    }
    if (['MEXICO'].includes(str)) {
      return 'México';
    }
    if (['MICHOACAN'].includes(str)) {
      return 'Michoacán';
    }
    if (['NUEVO LEON'].includes(str)) {
      return 'Nuevo León';
    }
    if (['QUERETARO'].includes(str)) {
      return 'Querétaro';
    }
    if (['SAN LUIS POTOSI'].includes(str)) {
      return 'San Luis Potosí';
    }
    if (['YUCATAN'].includes(str)) {
      return 'Yucatán';
    }
    const lowerCaseStr = str.toLowerCase(); // Convertir toda la cadena a minúsculas

    const words = lowerCaseStr.split(' '); // Dividir la cadena en palabras

    const capitalizedWords = words.map((word, index) => {
      if (index === 0) {
        // Mayúscula en la primera palabra
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    });

    // Unir las palabras capitalizadas
    return capitalizedWords.join(' ');
  };

  /** Manejo del título en las tarjetas */
  const handleMonitoringTitle = () => {
    const indicadorCount = (
      <Col xs={16} sm={8} md={12} align="middle">
        <h2
          style={{
            marginTop: '-10px',
            fontSize: '1.2rem',
            color: '#6e6e6e',
            fontWeight: '600',
            justifyContent: 'flex-start'
          }}>
          {nombre}
        </h2>
        <p
          style={{
            marginTop: '-10px',
            fontSize: '2rem',
            color: idTipo === INDICADOR_INTERNET ? '#c12b7d' : '#a867ee',
            fontWeight: '600'
          }}>
          {resumen.total}
        </p>
      </Col>
    );
    if (idTipo === INDICADOR_ESPECTACULARES) {
      return (
        <Col xs={8} sm={24} md={12} align="middle">
          <p style={{ marginTop: '0px', fontSize: '2rem', color: '#36abbe', fontWeight: '600' }}>
            {resumen.total}
          </p>
          <h2
            style={{
              marginTop: '-30px',
              fontSize: '1.3rem',
              color: '#6e6e6e',
              fontWeight: '600',
              justifyContent: 'flex-start'
            }}>
            {nombre}
          </h2>
        </Col>
      );
    }

    if (idTipo === INDICADOR_EVENTOS || idTipo === INDICADOR_CASAS) {
      return (
        <Col
          xs={8}
          sm={8}
          md={12}
          align="middle"
          style={{ width: 'fit-content', marginTop: '-10px' }}>
          <p
            style={{
              marginTop: '0px',
              width: '100%',
              fontSize: '1.8rem',
              color: idTipo === INDICADOR_EVENTOS ? '#36abbe' : '#a867ee',
              fontWeight: '600'
            }}>
            {resumen.total}
          </p>
          <h2
            style={{
              marginTop: '-30px',
              width: idTipo === INDICADOR_EVENTOS ? '110%' : '100%',
              fontSize: '1rem',
              color: '#6e6e6e',
              fontWeight: '600',
              justifyContent: 'flex-start'
            }}>
            {nombre}
          </h2>
        </Col>
      );
    }

    return indicadorCount;
  };

  /** Manejo de la imagen */
  const handleImage = () => {
    const imageFix = (
      <img key={llave} src={handleGetFileUriSvg(resumen.img_64)} alt="" width="fit-content" />
    );
    if (idTipo === INDICADOR_EVENTOS) {
      return (
        <div
          style={{
            width: 'fit-content',
            display: 'flex',
            alignContent: 'center',
            justifyContent: 'right',
            marginLeft: '55px'
          }}>
          <img key={llave} src={handleGetFileUriSvg(resumen.img_64)} alt="" width="80%" />
        </div>
      );
    }
    if (idTipo === INDICADOR_CASAS) {
      return (
        <div
          style={{
            width: 'fit-content',
            display: 'flex',
            alignContent: 'center',
            justifyContent: 'right'
          }}>
          <img
            key={llave}
            src={handleGetFileUriSvg(resumen.img_64)}
            alt=""
            width="95%"
            style={{ marginLeft: '10px' }}
          />
        </div>
      );
    }
    if (idTipo === INDICADOR_INTERNET) {
      return (
        <div
          style={{
            width: 'fit-content',
            display: 'flex',
            alignContent: 'center',
            justifyContent: 'right'
          }}>
          <img key={llave} src={handleGetFileUriSvg(resumen.img_64)} alt="" width="90%" />
        </div>
      );
    }
    if (idTipo === INDICADOR_M_I) {
      return (
        <div
          style={{
            width: 'fit-content',
            display: 'flex',
            alignContent: 'center',
            justifyContent: 'right'
          }}>
          <img
            key={llave}
            src={handleGetFileUriSvg(resumen.img_64)}
            alt=""
            width="90%"
            style={{ marginTop: '-12px' }}
          />
        </div>
      );
    }
    if (idTipo === INDICADOR_ESPECTACULARES) {
      return (
        <div
          style={{
            width: 'fit-content',
            display: 'flex',
            alignContent: 'center',
            justifyContent: 'right'
          }}>
          <img key={llave} src={handleGetFileUriSvg(resumen.img_64)} alt="" width="105%" />
        </div>
      );
    }

    return imageFix;
  };

  const handleDetail = () => {
    return detalle.map((edo) => (
      <Row
        justify="rigth"
        style={{
          marginTop: '10px',
          fontSize: '0.8rem',
          color: '#633C85'
        }}>
        <span className="name-country">{capitalizeWords(edo?.nombreEstado)}</span>{' '}
        <span className="two-dots">:</span>
        <span className="total-detail">{edo.total}</span>
      </Row>
    ));
  };

  return (
    <div className="flip-card" onMouseEnter={handleFlip} onMouseLeave={handleFlip}>
      <div className={`flip-card-inner ${flipped ? 'flipped' : ''}`}>
        <div className="flip-card-front">
          <Card hoverable style={{ height: '150px' }}>
            <Row>
              {handleMonitoringTitle()}
              <Col xs={8} sm={24} md={12} style={{ marginTop: '-10px', justifyContent: 'center' }}>
                {handleImage()}
              </Col>
            </Row>
          </Card>
        </div>
        <div className="flip-card-back">
          <Card hoverable style={{ height: '150px', backgroundColor: '#f3e9fd' }}>
            <Row gutter={4} className="detail-container">
              <Col xs={24} sm={24} md={16}>
                {handleDetail()}
              </Col>
              <Col xs={8} sm={24} md={8}>
                <Row>
                  <div style={{ width: '100%', marginTop: '5%' }}>{handleImage()}</div>
                </Row>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default FlipCard;

FlipCard.propTypes = {
  detalle: PropTypes.arrayOf(
    PropTypes.shape({
      nombreEstado: PropTypes.string.isRequired,
      total: PropTypes.number.isRequired
    }).isRequired
  ).isRequired,
  idTipo: PropTypes.number.isRequired,
  nombre: PropTypes.string.isRequired,
  resumen: PropTypes.shape({
    img_64: PropTypes.string.isRequired,
    total: PropTypes.number.isRequired,
    urlImagen: PropTypes.string
  }).isRequired,
  handleGetFileUriSvg: PropTypes.func.isRequired,
  llave: PropTypes.number.isRequired
};
